<template>
	<div v-if="src" @click="$emit('click')" class="flex justify-center items-center">
		<img
			:src="imageSource"
			:alt="alt"
			ref="image"
			v-show="isLoaded"
			@load="isLoaded = true"
			class="object-contain max-h-full"
			@click="index = 0"
			:class="{ 'cursor-pointer': showBig, rounded: showRounded }"
		/>
		<canvas id="c" style="display: none" />

		<LoadingSpinner v-if="!isLoaded" />
		<CoolLightBox :items="[src]" :index="index" @close="close" v-if="showBig" />
	</div>
</template>

<script>
import CoolLightBox from 'vue-cool-lightbox';
import LoadingSpinner from '@/components/navigation/LoadingSpinner';

export default {
	name: 'BaseImage',
	components: { LoadingSpinner, CoolLightBox },
	props: {
		src: {},
		alt: {},
		showBig: { default: true },
		showRounded: { required: false, default: true },
		rotation: { required: false, default: 0 },
	},
	methods: {
		close() {
			this.index = null;
		},
		rotateImage(srcBase64, degrees, callback) {
			const canvas = document.getElementById('c');
			const ctx = canvas.getContext('2d');

			const image = new Image();

			image.onload = function() {
				canvas.width = degrees % 180 === 0 ? image.width : image.height;
				canvas.height = degrees % 180 === 0 ? image.height : image.width;

				ctx.translate(canvas.width / 2, canvas.height / 2);
				ctx.rotate((degrees * Math.PI) / 180);
				ctx.drawImage(image, image.width / -2, image.height / -2);

				callback(canvas.toDataURL());
			};

			image.src = srcBase64;
		},
	},
	computed: {
		rotate() {
			return this.rotation;
		},
	},
	mounted() {
		this.imageSource = this.src;
	},
	data() {
		return {
			isLoaded: false,
			index: null,
			imageSource: '',
		};
	},
	watch: {
		rotation() {
			// eslint-disable-next-line @typescript-eslint/no-this-alias
			const context = this;
			this.rotateImage(this.src, this.rotation, function(resultBase64) {
				context.imageSource = resultBase64;
				context.$emit('tempDoc', resultBase64);
			});
		},
		src() {
			this.imageSource = this.src;
		},
	},
};
</script>

<style scoped></style>
